/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Slider } from '@mui/material';
import DatePicker from 'react-datepicker';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import {
  format, addDays, subDays, getYear, getUnixTime,
} from 'date-fns';
import TabLinks from '../../../components/TabLinks/TabLinks';

interface PropsSecondLine {
  orgActivityStartDate: Date;
  calanderStartDate: Date;
  handleStartDate: (e: any) => void;
  calanderEndDate: Date;
  handleEndDate: (e: any) => void;
  sliderValue: number[];
  handleSliderChange: (event: Event, newValue: any) => void;
  handleSliderLabel: (value?: any) => string;
  tabValues: {
    name: string;
    value: string;
    active: boolean;
  }[];
  handleTab: (e: any) => void;
}

/**
 * The date/granularity meta row. Sits between the toolbar card and the chart
 * card as plain page content rather than a card of its own, matching the
 * agreed design. Behaviour is unchanged — same pickers, slider and tabs.
 */
export default function SecondLine(props: PropsSecondLine) {
  const {
    orgActivityStartDate,
    calanderStartDate,
    handleStartDate,
    calanderEndDate,
    handleEndDate,
    sliderValue,
    handleSliderChange,
    handleSliderLabel,
    tabValues,
    handleTab,
  } = props;

  const labelSx = {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '13px',
    color: 'rgb(100,100,100)',
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '18px',
        flexWrap: 'wrap',
        margin: '0 4px 14px',
      }}
    >
      <Box sx={labelSx}>
        <CalendarTodayIcon sx={{ fontSize: '15px' }} />
        Start date
        <form autoComplete="off">
          <DatePicker
            autoComplete="off"
            minDate={orgActivityStartDate}
            maxDate={subDays(new Date(), 1)}
            selected={calanderStartDate}
            dateFormat="dd/MM/yyyy"
            onChange={(date: any) => handleStartDate(date)}
            className="w-100 outline-0 cursor-pointer bg-transparent font-medium text-customFontColor"
          />
        </form>
      </Box>

      <Box sx={labelSx}>
        <CalendarTodayIcon sx={{ fontSize: '15px' }} />
        End date
        <form autoComplete="off">
          <DatePicker
            minDate={addDays(calanderStartDate, 1)}
            maxDate={new Date()}
            selected={calanderEndDate}
            dateFormat="dd/MM/yyyy"
            onChange={(date: any) => handleEndDate(date)}
            className="w-100 outline-0 cursor-pointer bg-transparent font-medium text-customFontColor"
          />
        </form>
      </Box>

      <Box sx={{ display: { xs: 'none', xl: 'flex' }, alignItems: 'center' }}>
        <span className="font-normal text-customFontColor">
          {getYear(orgActivityStartDate)}
        </span>
        <Slider
          size="small"
          getAriaLabel={() => 'Date range'}
          value={sliderValue as number[]}
          onChange={handleSliderChange}
          valueLabelFormat={handleSliderLabel}
          valueLabelDisplay="auto"
          step={86400}
          min={getUnixTime(orgActivityStartDate)}
          max={getUnixTime(new Date(format(new Date(), 'yyyy-MM-dd')))}
          sx={{ width: '200px', margin: '0 20px' }}
        />
        <Box className="font-normal text-customFontColor">
          {getYear(new Date())}
        </Box>
      </Box>

      <Box sx={{ marginLeft: 'auto' }}>
        <TabLinks data={tabValues} func={handleTab} />
      </Box>
    </Box>
  );
}
